import { useQuery, gql } from '@zenbusiness/application-commons-graphql';

export const GET_ORDERS_QUERY = gql`
  query GetOrdersQuery($businessEntityUuid: UUID!) {
    accountInfo {
      accountUuid
      orders(businessEntityUuid: $businessEntityUuid) {
        status
        orderTasksLegacy {
          orderTaskStatus
          orderTaskType
          createdDatetime
          orderTaskStatusUpdates {
            createdDatetime
          }
        }
      }
    }
  }
`;

export const MERCHANT_ACCOUNT_HOLDER = gql`
  query MerchantAccountHolder($accountUuid: UUID!) {
    merchantAccountHolder(accountUuid: $accountUuid) {
      accountUuid
      status
      onboardingStatus
      merchantAccounts {
        businessEntityUuid
        providerStatus
      }
    }
  }
`;

export const useOrders = (businessEntityUuid) => {
  const { loading, data: { accountInfo: { orders } = {} } = {} } = useQuery(GET_ORDERS_QUERY, {
    variables: { businessEntityUuid }
  });
  return { loading, orders: orders || [] };
};

export const useMerchantAccountHolder = (accountUuid) => {
  const { data } = useQuery(MERCHANT_ACCOUNT_HOLDER, {
    variables: { accountUuid }
  });
  return data?.merchantAccountHolder;
};
